/*
 * @namespace Storage
 * @aka COMMON.Storage
 */
COMMON.Storage = function () {

  var keyPrefix = 'common/';
  var dataStore = {
    localStorage: {},
    sessionStorage: {}
  };

  /**
   * ------------------------------------------------------------------------
   * Private Helpers
   * ------------------------------------------------------------------------
   */

  function normalizeKey(key) {
    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
      console.warn(key + ' used as a key, but it is not a string.');
      key = String(key);
    }

    return key;
  }

  function serialize(value) {
    try {
      return JSON.stringify(value)
    } catch (e) {
      console.error("Couldn't convert value into a JSON string: ", value);
      return null;
    }
  }

  function deserialize(value) {
    return JSON.parse(value);
  }

  /**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */

  // Check if localStorage throws when saving an item
  function checkIfLocalStorageThrows() {
    var localStorageTestKey = '_localstorage_support_test';

    try {
      window.localStorage.setItem(localStorageTestKey, true);
      window.localStorage.removeItem(localStorageTestKey);

      return false;
    } catch (e) {
      return true;
    }
  }

  /**
   * The getItem() method of the Storage interface, when passed a key name, will return that key's value or null if the key does not exist.
   *
   * @param storageName
   * @param key
   * @returns {string}
   */
  function getItem(storageName, key) {
    key = normalizeKey(key);

    var data,
      result;

    try {
      var storage = 'localStorage' === storageName ? localStorage : sessionStorage;

      data = storage.getItem(keyPrefix + key);
    } catch (e) {
      data = dataStore[storageName].hasOwnProperty(keyPrefix + key) ? dataStore[storageName][keyPrefix + key] : undefined;
    }

    // If a result was found, parse it from the serialized
    // string into a JS object. If result isn't truthy, the key
    // is likely undefined
    if (data) {
      data = deserialize(data);
      if ('object' === typeof data && data.hasOwnProperty('value') && data.hasOwnProperty('expires')) {
        if (null !== data.expires) {
          var expires = new Date(data.expires);
          if (new Date().getTime() >= expires.getTime()) {
            removeItem(storageName, key);
            return result;
          }
        }
        result = data.value;
      } else {
        // @depricated
        result = data;
      }
    }

    return result;
  }

  /**
   * The removeItem() method of the Storage interface, when passed a key name, will remove that key from the storage if it exists. If there is no item associated with the given key, this method will do nothing.
   *
   * @param storageName
   * @param key
   */
  function removeItem(storageName, key) {
    key = normalizeKey(key);

    try {
      var storage = 'localStorage' === storageName ? localStorage : sessionStorage;

      storage.removeItem(keyPrefix + key);
    } catch (e) {
      delete dataStore[storageName][keyPrefix + key];
    }
  }

  /**
   * The setItem() method of the Storage interface, when passed a key name and value, will add that key to the storage, or update that key's value if it already exists.
   *
   * @param storageName
   * @param key
   * @param value
   * @param expires
   * @returns {boolean|void}
   */
  function setItem(storageName, key, value, expires) {
    key = normalizeKey(key);

    // Convert undefined values to null.
    if (value === undefined) {
      value = null;
    }

    expires = ('undefined' !== typeof expires && expires instanceof Date) ? expires : null;
    var data = {
      value: value,
      expires: expires
    };

    try {
      data = serialize(data);
    } catch (e) {
      return false;
    }

    try {
      var storage = 'localStorage' === storageName ? localStorage : sessionStorage;

      storage.setItem(keyPrefix + key, data);
    } catch (e) {
      dataStore[storageName][keyPrefix + key] = data;
    }
  }

  var Storage = {
    available: !checkIfLocalStorageThrows(),
    session: {
      getItem: function (key) {
        return getItem('sessionStorage', key)
      },
      removeItem: function (key) {
        return removeItem('sessionStorage', key)
      },
      setItem: function (key, value, expires) {
        return setItem('sessionStorage', key, value, expires)
      }
    },
    local: {
      getItem: function (key) {
        return getItem('localStorage', key)
      },
      removeItem: function (key) {
        return removeItem('localStorage', key)
      },
      setItem: function (key, value, expires) {
        return setItem('localStorage', key, value, expires)
      }
    }
  };

  return Storage;

}();
